/**
 * Fonte única do enum no frontend. Espelha os valores de `sys_choice` para
 * `sys_ui_rules.effect_type`, que é a fonte de verdade — o backend valida a
 * escrita contra ela (`SysRecord#choice_values_within_configured_options`).
 * Qualquer valor fora desta lista é regra inerte: ao adicionar um efeito novo,
 * as duas pontas mudam juntas.
 */
export const UI_RULE_EFFECT_TYPES = [
    "show",
    "hide",
    "show_required",
    "hide_optional",
    "require",
    "optional",
    "readonly",
    "editable",
] as const;

export type UiRuleEffectType = (typeof UI_RULE_EFFECT_TYPES)[number];

export const isUiRuleEffectType = (value: unknown): value is UiRuleEffectType =>
    UI_RULE_EFFECT_TYPES.includes(value as UiRuleEffectType);

interface ISysUiRuleParams {
    id: string;
    name: string;
    description?: string;
    active: boolean;
    sys_table_id: string;
    target_column_id: string;
    effect_type: string;
    condition: unknown;
    applies_on: "create" | "edit" | "both";
    priority: number;
    invert_on_condition_miss: boolean;
    clear_value_when_hidden: boolean;
    stop_processing: boolean;
    created_at: Date | string;
    updated_at: Date | string;
}

class SysUiRule {
    constructor();
    constructor(data: ISysUiRuleParams);
    constructor(data?: ISysUiRuleParams) {
        this.id = data?.id ?? "";
        this.name = data?.name ?? "";
        this.description = data?.description ?? "";
        this.active = data?.active ?? true;
        this.sys_table_id = data?.sys_table_id ?? "";
        this.target_column_id = data?.target_column_id ?? "";
        this.effect_type = data?.effect_type ?? "";
        this.condition = data?.condition ?? null;
        this.applies_on = data?.applies_on ?? "both";
        this.priority = data?.priority ?? 100;
        this.invert_on_condition_miss = data?.invert_on_condition_miss ?? true;
        this.clear_value_when_hidden = data?.clear_value_when_hidden ?? false;
        this.stop_processing = data?.stop_processing ?? false;
        this.created_at = data?.created_at ? new Date(data.created_at) : new Date();
        this.updated_at = data?.updated_at ? new Date(data.updated_at) : new Date();
    }

    id: string;
    name: string;
    description: string;
    active: boolean;
    sys_table_id: string;
    target_column_id: string;
    effect_type: string;
    condition: unknown;
    applies_on: "create" | "edit" | "both";
    priority: number;
    invert_on_condition_miss: boolean;
    clear_value_when_hidden: boolean;
    stop_processing: boolean;
    created_at: Date;
    updated_at: Date;
}

export default SysUiRule;
